import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import MediaCategoryListForm from '@src/features/tenant/mediaCategories/MediaCategoryListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function MediaCategoryList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <MediaCategoryListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default MediaCategoryList;
